module.exports = __webpack_public_path__ + "static/media/Iceland.d260e4c0.png";